import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {withBoundary} from './ErrorBoundary'
import NotFound from './NotFound'

@withBoundary
@inject('store') @observer
class Sentry extends Component {
  componentDidMount() {
    this.throwError()
  }
  throwError = () => {
    const {is_staff} = this.props.store.user.data
    if (is_staff) {
      throw new Error('Sentry test')
    }
  }
  render() {
    return <NotFound/>
  }
}

export default Sentry
